import React from 'react';
import classNames from 'classnames';
var Point = function (props) {
    var x = props.x, y = props.y, className = props.className, size = props.size, onMouseOver = props.onMouseOver, onMouseOut = props.onMouseOut, _a = props.hovered, hovered = _a === void 0 ? false : _a;
    return (React.createElement("circle", { r: size, cx: x, cy: y, className: classNames('point', className, { hovered: hovered }), onMouseOver: onMouseOver ? function () { return onMouseOver(props); } : undefined, onMouseOut: onMouseOut ? function () { return onMouseOut(props); } : undefined }));
};
export default Point;
//# sourceMappingURL=Point.js.map